<div class="chart-close-modal">
  <button class="buttonCloseChartModal" (click)="ClosePopup()" title="Fermer">Fermer</button>
</div>